import { useGetActionsFromUrl } from "../useGetActionsFromUrl";
const useGetSuccessAuthRedirection = token => {
  const action = useGetActionsFromUrl();
  const hasRedirectToSA = action === "opensa";
  const urlWithToken = hasRedirectToSA ? `/travel/support-area/#sahome/${token}/` : `/travel/secure/?origin=mytripslogin#tripdetails/td=${token};`;
  const urlWithOutToken = hasRedirectToSA ? "/travel/support-area/#sahome/" : "/travel/membership-pages/#membership_mytrips_reactivation/";
  return token ? urlWithToken : urlWithOutToken;
};
export default useGetSuccessAuthRedirection;